import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
    selector: 'input[type=number]'
})
export class InputNumberDirective {
   
    @HostListener('wheel', ['$event']) handleWheelEvent(event) { event.preventDefault(); }

    constructor(private _element: ElementRef) { }

}
